'use client'
import React, { useState, useEffect, useRef } from 'react'
import { saleTypes } from '@constants/saleBasicTypes'
import { categoryTypes } from '@constants/categoryTypes'
import { serviceHouseRoomTypes } from '@constants/serviceHouseRoomTypes'
import { serviceCondoRoomTypes } from '@constants/serviceCondoRoomTypes'
import { updateSearchParams, removeParams, removeSearchParam } from "@utils";
import { useRouter } from 'next/navigation'
import CategoriesFilter from '@components/Search/WebFilter/CategoriesFilter'
import RoomFilter from '@components/Search/WebFilter/RoomFilter'
import SaleFilter from '@components/Search/WebFilter/SaleFilter'
import MinPriceFilter from '@components/Search/WebFilter/MinPriceFilter'
import MaxPriceFilter from '@components/Search/WebFilter/MaxPriceFilter'
import MinRentPriceFilter from '@components/Search/WebFilter/MinRentPriceFilter'
import MaxRentPriceFilter from '@components/Search/WebFilter/MaxRentPriceFilter'
import SortFilter from '@components/Search/WebFilter/SortFilter'
import PetFriendlyFilter from '@components/Search/WebFilter/PetFriendlyFilter'
import SeaViewFilter from '@components/Search/WebFilter/SeaViewFilter'
import BeachfrontFilter from '@components/Search/WebFilter/BeachfrontFilter'
import DistrictFilter from '@components/Search/WebFilter/DistrictFilter'




const WebFilterTab = ({ searchParams, districtList, dictionary, lang }) => {
    const router = useRouter();

    const filterRef = useRef(null);


    // const [isFilterOpen, setIsFilterOpen] = useState(router?.query?.filter || false);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [filterOn, setFilterOn] = useState(false);
    const [search, setSearch] = useState(searchParams)
    const [salePriceFilter, setSalePriceFilter] = useState(searchParams.saleType || saleTypes[0].value)
    const [categoryFilter, setCategoryFilter] = useState(searchParams.category)
    // const [sort, sortFilter] = useState(searchParams.sort || 'datedesc')
    const [showMap, setShowMap] = useState(searchParams.map || false);

    useEffect(() => {
        function openFilterTab() {
            setIsFilterOpen(true)
        }

        let openFilter = searchParams.filtertab

        if (openFilter == 'true') {
            openFilterTab()
        }
    }, [])

    const handleMapChange = (e) => {
        setShowMap(e);
        let newPathName
        if (e == true) {
            newPathName = updateSearchParams('map', true);
        } else {
            newPathName = removeSearchParam('map');
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        if (!filterRef?.current) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    // filterRef.current.style.position = 'sticky';
                    filterRef.current.style.top = '0';
                    // filterRef.current.style.zIndex = '0';
                }/* else {
                    filterRef.current?.style.position = 'absolute';
                    filterRef.current?.style.top = '20px'; // Adjust as needed
                }*/
            },
            {
                root: null,
                threshold: 0,
            }
        );

        observer.observe(filterRef.current);

        // return () => {
        //     observer.unobserve(filterRef.current);
        // };
    }, []);

    useEffect(() => {
        // const searchPar = new URLSearchParams(window.location.search);
        if (search != searchParams) {
            setSearch(searchParams)
            if (searchParams.saleType === 'rent') {
                setSalePriceFilter('rent')
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            } else {
                setSalePriceFilter(saleTypes[0].value)
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            }

            if (searchParams.category === 'condo') {
                setCategoryFilter('condo')
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            } else if (searchParams.category === 'house') {
                setCategoryFilter('house')
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            } else if (searchParams.category == undefined) {
                setCategoryFilter(undefined)
            } else {
                setCategoryFilter('')
            }

            if (searchParams.category !== undefined || searchParams.district !== undefined || searchParams.minprice !== undefined || searchParams.maxprice !== undefined) {
                setFilterOn(true)
            } else {
                setFilterOn(false)
            }
        }
    }, [searchParams])

    return (
        <>
            <div className='w-full mb-4 z-[80]' ref={filterRef}>
                {!isFilterOpen && (
                <div className='sm:w-full 2xl:w-10/12 max-w-[1600px] bg-light flex flex-col justify-between items-center px-3 pt-2 shadow-md rounded-b-md border-b-[1px] border-forth mx-auto'>
                    <div className='w-full flex flex-row items-center justify-between'>
                        <div className='w-1/3 px-2'>
                            {saleTypes.length > 1 &&
                                <SaleFilter title="saleType" options={saleTypes} lang={lang} dictionary={dictionary} />
                            }
                        </div>
                        <div className='w-1/3 px-2'>
                            <CategoriesFilter title="categories" options={categoryTypes} lang={lang} dictionary={dictionary} />
                        </div>
                        <div className='w-1/3 px-2'>
                            {(categoryFilter === 'condo' || categoryFilter === undefined || categoryFilter === 'all') &&
                                <RoomFilter title="room" roomTypes={serviceCondoRoomTypes} lang={lang} dictionary={dictionary} />
                            }
                            {(categoryFilter === 'house' || categoryFilter === 'poolvilla') &&
                                <RoomFilter title="room" roomTypes={serviceHouseRoomTypes} lang={lang} dictionary={dictionary} />
                            }
                        </div>
                    </div>
                    <div className='w-full flex flex-row items-center justify-center mt-8'>
                        <div onClick={() => (setIsFilterOpen(true))} className='absolute bg-light b-[-30px] w-[200px] flex flex-row items-center justify-center border-[1px] rounded-md shadow-md border-forth hover:border-maincolor hover:bg-maincolor text-maincolor hover:text-white p-1 cursor-pointer' title='Toggle Filter'>
                            {filterOn && (
                                <div className='absolute h-2 w-2 rounded-full bg-third top-1 right-1 z-30'></div>
                            )}
                            <span className=' mr-1 select-none'>{dictionary.more}</span>
                        </div>

                    </div>
                </div>
                )}
                {isFilterOpen ? (
                    <div className='relative top-0 left-0 right-0 z-[99] '>
                        <div className='sm:w-full 2xl:w-10/12 max-w-[1600px] mx-auto bg-light shadow-md px-3 pt-2 rounded-b-md'>
                        <div className='w-full flex flex-row items-center justify-between'>
                            <div className='w-1/3 px-2'>
                                {saleTypes.length > 1 &&
                                    <SaleFilter title="saleType" options={saleTypes} lang={lang} dictionary={dictionary} />
                                }
                            </div>
                            <div className='w-1/3 px-2'>
                                <CategoriesFilter title="categories" options={categoryTypes} lang={lang} dictionary={dictionary} />
                            </div>
                            <div className='w-1/3 px-2'>
                                {(categoryFilter === 'condo' || categoryFilter === undefined || categoryFilter === 'all') &&
                                    <RoomFilter title="room" roomTypes={serviceCondoRoomTypes} lang={lang} dictionary={dictionary} />
                                }
                                {categoryFilter === 'house' &&
                                    <RoomFilter title="room" roomTypes={serviceHouseRoomTypes} lang={lang} dictionary={dictionary} />
                                }
                            </div>
                        </div>
                            <div className='w-full flex sm:flex-row flex-col sm:items-start mt-1'>
                                <div className='w-2/3'>
                                    {salePriceFilter === 'sale' ? (
                                        <div className='w-full flex flex-row'>
                                            <MinPriceFilter title="minprice" dictionary={dictionary} lang={lang} />
                                            <MaxPriceFilter title="maxprice" dictionary={dictionary} lang={lang} />
                                        </div>
                                    ) : (
                                        <div className='w-full flex flex-row'>
                                            <MinRentPriceFilter title="minprice" dictionary={dictionary} lang={lang} />
                                            <MaxRentPriceFilter title="maxprice" dictionary={dictionary} lang={lang} />
                                        </div>
                                    )}
                                </div>
                                <div className='w-1/3 px-2'>
                                    <SortFilter title='sort' dictionary={dictionary} />
                                </div>
                            </div>
                            <div className='w-full flex flex-row'>
                                <div className='w-1/3 px-2'>
                                    <div className='w-full flex flex-col'>
                                        {(categoryFilter == 'land' || categoryFilter == 'commercial') ? null : (
                                            <>
                                                <PetFriendlyFilter title='petfriendly' dictionary={dictionary} />
                                                <SeaViewFilter title='seaview' dictionary={dictionary} />
                                                <BeachfrontFilter title='beachfront' dictionary={dictionary} />
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className='w-1/3 px-2'>
                                    <DistrictFilter title="district" districtList={districtList} dictionary={dictionary}/>
                                </div>
                                <div className='w-1/3 px-2'>
                                    <div className='w-full h-full flex flex-row items-end mt-4 mb-3'>
                                        <div className='w-full pb-4'>
                                            <button className='bg-third text-light rounded-md p-1 font-semibold sm:1/3 w-1/2' onClick={() => removeParams()}>{dictionary.reset}</button>
                                            <button className='bg-maincolor text-light rounded-md p-1 font-semibold sm:1/3 w-1/2' onClick={() => (setIsFilterOpen(false))}>{dictionary.seeResults}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full mt-8 relative flex flex-row items-center'>
                                <div className='absolute left-0 right-0 bottom-[-15px] flex justify-center'>
                                    <div onClick={() => (setIsFilterOpen(false))} className='relative w-[200px] flex flex-row items-center justify-center border-[1px] rounded-md bg-light border-third hover:border-maincolor hover:bg-maincolor text-maincolor hover:text-white p-1 cursor-pointer'>
                                        {filterOn && (
                                            <div className='absolute h-2 w-2 rounded-full bg-third top-1 right-1 z-30'></div>
                                        )}
                                        <span className='mr-1 select-none'>{dictionary.close}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
                }
            </div >
            {isFilterOpen ? (
                <div onClick={() => (setIsFilterOpen(false))} className='fixed z-[30] top-0 bottom-0 left-0 right-0 bg-black bg-opacity-30'>
                </div>
            ) : null}
        </>
    )
}

export default WebFilterTab